import { helpers } from '../helpers.js';

var headerMenu = {
  options: {
      scrollThreshold: 50,
      isFixed: false,
  },

  selectors: {
    header: '.js-header',
    header_menu: '.js-header-menu',
		menu_toggle_button: '.js-header-toggle-button',
  },

  init: function () {
    const self = this;
    self.options.scrollThreshold = jQuery( window ).width() < 990 ? 57 : 100;

    self.toggleEvent();
    
    // Bind the method to the `headerMenu` context
    const boundUpdateHeaderPosition = self.updateHeaderPosition.bind(self);
    self.updateHeaderPosition = boundUpdateHeaderPosition;
    
    self.updateHeaderPosition();

    jQuery( window ).on('scroll', self.updateHeaderPosition );
  },

  updateHeaderPosition: function() {
    const self = this;

		// Only apply if body has .header-marquee and header is NOT open
		if (! jQuery( 'body' ).is(':has(.header-marquee)') || jQuery( self.selectors.header ).hasClass('header--open')) {
			return;
		}

		let scrollTop = jQuery(window).scrollTop();

		if (scrollTop > self.options.scrollThreshold && !self.options.isFixed) {
			// Transition to fixed
			 jQuery( self.selectors.header )
				.css({
					position: 'fixed',
					top: 0,
				});
			self.options.isFixed = true;
		} else if (scrollTop <= self.options.scrollThreshold && self.options.isFixed) {
			// Transition back to absolute
			 jQuery( self.selectors.header )
				.css({
					position: 'absolute',
					top: `${ self.options.scrollThreshold }px`,
				});
			self.options.isFixed = false;
		}

    if( jQuery(self.selectors.header).hasClass('header--open-prepare') ) {
      jQuery( self.selectors.header )
				.css({
					position: 'fixed',
					top: 0,
				});

        self.options.isFixed = true;
    }
	},

  toggleEvent: function () {
    const self = this;

    jQuery(self.selectors.menu_toggle_button).on('click', function (e) {
      e.preventDefault();

      if (!jQuery(self.selectors.header).hasClass('header--open')) {
        jQuery(self.selectors.header).addClass('header--open-prepare');

        setTimeout(function () {
          jQuery(self.selectors.header).addClass('header--open');
        }, 20);
      } else {
        jQuery(self.selectors.header).removeClass('header--open');
        jQuery(self.selectors.header).removeClass('header--open-prepare');
      }

      self.updateHeaderPosition();
    });
  },
}

// Export
export { headerMenu };